<template>
    <div id="post-inspector" :class="{open:isOpen, dark:(theme==='dark')}">
        <a class="closer" href="#" @click.prevent="pushClose"><icon icon="times"/></a>
        <div class="scroll-container">

            <div v-if="postExists">
                <h4 v-if="postExists">{{post.post.title}}</h4>
                <div class="poweredby">
                    <small>powered by</small>
                    <portal-logo :post="post" mh="20px" usebg="true"/>
                </div>
                <img v-if="post.post.preview" :src="post.post.preview" class="img-fluid">
            </div>

            <loading-indicator name="post.extendedInfo"/>

            <div v-if="postDataExists">
                <div class="row">
                    <div class="col">
                        {{postData.likeCount}} Like<span v-if="postData.likeCount!=1">s</span>
                    </div>
                    <div class="col text-right">
                        <a href="#" @click.prevent="showTrail = !showTrail">posted {{postData.blogs.length}} time<span v-if="postData.blogs.length!=1">s</span></a>
                    </div>
                </div>

                <div v-show="showTrail" class="trail-list">
                    <div v-for="blog in postData.blogs" class="blog-item">
                        <a href="#" @click.prevent="showBlog(blog)"><blog-avatar :blog="blog" :w="28" :h="28"/> &nbsp;{{blog.title | maxlen(30)}}</a>
                    </div>
                </div>

                <div class="commentForm">
                    <div class="form-group">
                        <label>Leave a Comment:</label>
                        <textarea v-model="commentStr" placeholder="Your Comment..." class="form-control"></textarea>
                    </div>

                    <button class="btn btn-primary" :disabled="commentStr.length===0 || isPostingComment" @click.prevent="postComment">
                        <icon v-if="isPostingComment" icon="circle-notch" spin/>
                        Post
                    </button>
                </div>

                <div class="comments">
                    <div v-for="comment in postData.comments" class="comment">
                        <div class="author">
                            {{comment.user.name}}
                            <a v-if="isMine(comment)" href="#" @click.prevent="deleteComment(comment)"><icon icon="trash"/></a>
                        </div>
                        <p class="text">
                            {{comment.text}}
                        </p>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
  import PortalLogo from '../ui/PortalLogo';
  import LoadingIndicator from "../ui/LoadingIndicator";
  import BlogAvatar from "../ui/BlogAvatar";
  import Icon from "../ui/Icon";

  export default {
    name: "PostInspector",
    data(){
      return {
        isOpen: false,
        theme: 'light',
        post: {},
        postData: {},
        commentStr: '',
        isPostingComment: false,
        showTrail: false
      }
    },
    computed: {
      postExists(){
        return (this.post.post) ? true : false;
      },
      postDataExists(){
        return (this.postData.post) ? true : false;
      }
    },
    mounted(){
      this.$bus.$on('postInspector.show', (data)=>{
        this.isOpen = true;
        this.post = data.post;
        this.theme = data.theme;
        this.$api.getExtendedPostInfo(this.post)
          .then((res)=>this.postData = res.data);
      });
      this.$bus.$on('postInspector.hide', ()=>{
        this.closeInspector();
      });
      this.$bus.$on('modal.open', (modal) => { if(modal==='player') this.theme = 'dark' });
      this.$bus.$on('modal.close', (modal) => { if(modal==='player') this.theme = 'light' });
    },
    methods: {
      closeInspector(){
        this.isOpen = false;
        setTimeout(()=>{
          this.post = {};
          this.postData = {};
        },200);
      },
      pushClose(){
        this.$bus.$emit('postInspector.hide')
      },
      postComment(){
        this.isPostingComment = true;
        this.$api.postComment(this.post, this.commentStr)
          .then((res)=>{
            this.isPostingComment = false;
            this.commentStr = '';
            this.postData.comments.push(res.data.comment);
            this.$bus.$emit('success', 'Your Comment was added!');
          })
          .catch((err)=>{
            this.$bus.$emit('error', 'Could not Save your Comment');
            this.isPostingComment = false;
          })
      },
      isMine(comment){
        return comment.user.name === this.$store.getters['user/name'];
      },
      deleteComment(comment){
        this.$api.deleteComment(this.post, comment)
          .then((res)=>{
            this.postData.comments.splice(
              this.postData.comments.indexOf(comment),
              1
            );
            this.$bus.$emit('success', 'Your comment was deleted');
          })
          .catch((err)=>{
            this.$bus.$emit('error', 'Sorry, you can not delete this comment.');
          })
      },
      getBlogUrl(blog){
        return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
      },
      showBlog(blog){
        if(this.$route.path != this.getBlogUrl(blog)){
          this.$bus.$emit('blog-modal.open', {blog});
        }
      },
    },
    components: {
      Icon,
      BlogAvatar,
      LoadingIndicator,
      PortalLogo
    }
  }
</script>

<style scoped lang="sass">

    @import "../../assets/sass/vars.scss"
    $width: 350px

    #post-inspector
        position: fixed
        top: 0
        left: 0
        bottom: 0
        z-index: $z-postInspector
        width: 100%
        max-width: $width
        transform: translateX(-$width)
        background-color: rgba(255,255,255, .95)
        box-shadow: 5px 0 5px rgba(0,0,0,.2)
        opacity: 0
        transition: all ease-in-out 200ms
        overflow: hidden
        overflow-y: scroll

        &.open
            transform: translateX(0)
            opacity: 1

        &.dark
            background-color: rgba(10,10,10, .95)
            color: #FFFFFF

        .closer
            font-size: 2em
            display: block
            padding: 0px 20px 0 0
            text-align: right
            text-decoration: none
            color: #444

            &:hover
                color: $colorPrimary

        h4
            margin-top: -2em
            padding-right: 20px

        .poweredby
            margin-top: -.4em
            margin-bottom: .4em

        .scroll-container
            padding: 10px 20px 10px 10px


        .trail-list
            margin: 1em 0
            //display: none

            .blog-item
                margin: 4px 0

                a
                    text-decoration: none

        .commentForm
            margin: 1em 0

        .comments
            margin: 1em 0

            .comment
                background-color: $colorBodyBg
                margin-bottom: .5em
                padding: .5em
                border: 1px solid #EEE
                border-radius: 5px

                p
                    margin-bottom: 0

                .author
                    font-size: .8em

    #post-inspector.dark
        .close
            color: #FFF !important

        .comments
            .comment
                background-color: #1b1e21
                border-color: #2e3133

</style>



// WEBPACK FOOTER //
// src/components/posts/PostInspector.vue